/**
 * Mass Index — índice de massa (Donald Dorsey).
 *
 * Reescrito sobre os primitivos do engine Silverlight (silverlightDsl) para
 * ficar bit-exact com o original (FML.MASS, GraficoDePrata/Formulas/
 * FMLOutros.cs):
 *
 *   MASS = SUM( EMA(H−L, N1) / EMA(EMA(H−L, N1), N1), N2 )
 *
 * Duas diferenças vs. a versão anterior (porte do ChartIQ), decididas com o
 * usuário em 2026-07-21:
 * - `emaPeriod` (N1) passa a ser PARÂMETRO (antes era 9 fixo no código);
 * - o somatório usa o `SUM` do engine, cuja janela é **N2+1** termos (o porte
 *   ChartIQ somava N2) — é isso que dá a paridade com o gráfico legado.
 *
 * Paridade provada em __tests__/massIndex.silverlight.test.js.
 */
import { ema, sub, div, sum } from "./silverlightDsl";
import { MassIndex as defaultOptions } from "./defaultOptionsForComputation";

export default function () {
  let options = defaultOptions;

  function calculator(data) {
    const { period, emaPeriod } = options;
    const num = (v) => (Number.isFinite(v) ? v : NaN);
    const high = data.map((d) => num(d.high));
    const low = data.map((d) => num(d.low));

    const range = sub(high, low);
    const ema1 = ema(range, emaPeriod);
    const ema2 = ema(ema1, emaPeriod);
    const ratio = div(ema1, ema2);
    const mass = sum(ratio, period);

    return mass.map((v) => (Number.isFinite(v) ? v : undefined));
  }

  calculator.undefinedLength = () => {
    // O EMA do engine não tem warm-up NaN (seed = f[0]); o SUM emite a partir
    // de i > N2.
    return options.period + 1;
  };

  calculator.options = function (x) {
    if (!arguments.length) {
      return options;
    }
    options = { ...defaultOptions, ...x };
    return calculator;
  };

  return calculator;
}
